import React from "react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import PendenciasFinanceiras from "../../common/query/PendenciasFinanceiras";
import { Alert } from "flowbite-react";
import AcoesCiveis from "../../common/query/AcoesCiveis";
import ChequesSemFundos from "../../common/query/ChequesSemFundos";
import Protestos from "../../common/query/Protestos";

const PendenciasQuod = ({ data }) => {
  return (
    <>
      {data?.statusRetorno == 1 && (
        <>
          <div>
            <TitleStripe className="mb-5">
              IV - Pendências Bancárias
            </TitleStripe>

            {data?.pendenciasFinanceiras?.length > 0 ? (
              <div className="flex gap-2 items-start">
                <div className="flex-1">
                  <PendenciasFinanceiras
                    quantidadeTotal={
                      data?.resumoConsulta?.pendenciasFinanceiras
                        ?.quantidadeTotal
                    }
                    valorTotal={
                      data?.resumoConsulta?.pendenciasFinanceiras?.valorTotal
                    }
                    pendenciasFinanceiras={data?.pendenciasFinanceiras}
                  />
                </div>
              </div>
            ) : (
              <NoOcurrence />
            )}

            <TitleStripe className="mb-5">IV - Ações Cíveis</TitleStripe>

            {data?.acoesCiveis?.length > 0 ? (
              <div className="flex gap-2 items-start">
                <div className="flex-1">
                  <AcoesCiveis
                    quantidadeTotal={
                      data?.resumoConsulta?.acoesCiveis?.quantidadeTotal
                    }
                    acoesCiveis={data?.acoesCiveis?.slice(0, 5)}
                  />
                </div>
              </div>
            ) : (
              <NoOcurrence />
            )}

            <TitleStripe className="mb-5">IV - Protestos</TitleStripe>

            {data?.protestos?.length > 0 ? (
              <div className="flex gap-2 items-start">
                <div className="flex-1">
                  <Protestos
                    quantidadeTotal={
                      data?.resumoConsulta?.protestos?.quantidadeTotal
                    }
                    valorTotal={data?.resumoConsulta?.protestos?.valorTotal}
                    protestos={data?.protestos}
                    temVencimento={false}
                  />
                </div>
              </div>
            ) : (
              <NoOcurrence />
            )}

            <TitleStripe className="mb-5">IV - Cheques sem Fundo</TitleStripe>

            {data?.chequesSemFundo?.length > 0 ? (
              <div className="flex gap-2 items-start">
                <div className="flex-1">
                  <ChequesSemFundos
                    quantidadeTotal={
                      data?.resumoConsulta?.chequesSemFundo?.quantidadeTotal
                    }
                    valorTotal={
                      data?.resumoConsulta?.chequesSemFundo?.valorTotal
                    }
                    chequesSemFundos={data?.chequesSemFundo?.slice(0, 5)}
                  />
                </div>
              </div>
            ) : (
              <NoOcurrence />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default PendenciasQuod;
